// src/utils/assessment/defaults.js
// Default state objects and static configuration for the Assessment flow

export const INITIAL_FACILITY_INFO = {
  companyName: '',
  contactName: '',
  email: '',
  majorIndustry: '',
  subIndustry: '',
  subIndustryId: null,
  industry: '',
  state: '',
  country: 'Australia',
  region: 'naics' // Default to NAICS region
};

export const INITIAL_ENERGY_BASELINE = {
  annualKwh: '',
  annualElectricityCost: '',
  peakDemandKw: '',
  annualGasUsage: '',
  gasUsageUnit: 'therms',
  averageMonthlyBill: '',
  utilityRateType: '',
  hasEnergyMonitoring: '',
  hasHistoricalData: '',
  operatingHours: '',
  facilitySize: '',
  annualProduction: '',
  productionUnit: '',
  productionCapacity: '',
  averageProductionRate: '',
  annualRevenue: '',
  productionSeasons: '',
  qualityMetrics: ''
};


